{
  "profileMenu": {
    "ariaLabel": "Abre men&uacute; del perfil",
    "signOut": "Salir",
    "errorMessage": "Lo sentimos, no nos es posible cargar tu informaci&oacute;n de usuario. \nEs posible que la sesi&oacute;n no ha sido iniciada o ha sido terminada o que tu navegador est&eacute; bloqueando las cookies de terceros.",
    "loadingMessage": "Estamos intentando cargar tu informaci&oacute;n de usuario.<br /><br />Gracias por tu paciencia."
  },
  "applicationSwitcher": {
    "header": "Soluciones Cox Automotive"
  },
  "orgContextSelector": {
    "onboardingPrompt": "Seleccione su concesionario para comenzar",
    "noMemberships": "No hay concesionarios asignados",
    "loadError": "No se pueden cargar los concesionarios",
    "searchPlaceholder": "Buscar concesionarios",
    "searchPrompt": "Busque un concesionario para comenzar",
    "searchMinLength": "Siga escribiendo para buscar",
    "searchMaxLength": "La búsqueda es demasiado larga; acórtela",
    "searchLoading": "Buscando…",
    "searchNoResults": "Ningún concesionario coincide con su búsqueda",
    "searchError": "No se pueden buscar concesionarios",
    "searchRetry": "Vuelva a intentarlo"
  },
  "sideNav": {
    "ariaLabel": "Abrir menú de navegación lateral",
    "menuLabel": "Men&uacute;",
    "dashboardLabel": "Tableros",
    "productUpdatesLabel": "Actualizaciones de productos",
    "railAriaLabel": "Navegación lateral",
    "chevronShowMore": "Mostrar más elementos de navegación",
    "chevronBackToTop": "Volver arriba",
    "menuTitle": "Menú",
    "menuClose": "Cerrar menú"
  }
}
